import { t } from '@lingui/macro'
import { useMemo } from 'react'
import { useTheme } from 'styled-components'

import { FlexColumn, Padding } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { H2 } from '@/@bothrs-ui/web/components/typography/Heading'

type Props = {
  typeCopy: string
}

export const DocumentsEmptySection = ({ typeCopy }: Props) => {
  const theme = useTheme()

  const copy = useMemo(() => {
    switch (typeCopy) {
      case 'brochures': {
        return t({
          id: 'documents.type.brochures',
          message: 'brochures',
        })
      }
      case 'teTekenen': {
        return t({
          id: 'documents.type.teTekenen',
          message: 'te tekenen documenten',
        })
      }
      case 'getekend': {
        return t({
          id: 'documents.type.ondertekend.2',
          message: 'ondertekende documenten',
        })
      }
      default:
      case 'all':
      case 'documents': {
        return t({
          id: 'documents.type.documents',
          message: 'documenten',
        })
      }
    }
  }, [typeCopy])

  return (
    <FlexColumn alignItems='center' justifyContent='center' gap={theme.UI.Spacing.Space4} flexGrow={1}>
      <img style={{ width: '60%', maxWidth: '350px' }} src={'/img/svg/empty-documents.svg'} alt='lege inbox' />

      <Padding pb={theme.UI.Spacing.Space20}>
        <FlexColumn gap={theme.UI.Spacing.Space4} alignItems='center'>
          <H2 noMargin textAlign='center'>
            {t({
              id: 'documents.overview.empty.title',
              message: `Voorlopig heb je geen {copy}.`,
              values: { copy },
            })}
          </H2>
          <Span type='BodyLargeRegular' color={theme.Colors.Neutrals.Darker} textAlign='center'>
            {t({
              id: 'documents.overview.empty.description',
              message: `Wanneer er nieuwe {copy} beschikbaar zijn dan zul je hier een melding van krijgen, en worden ze automatisch toegevoegd aan deze pagina.`,
              values: { copy },
            })}
          </Span>
        </FlexColumn>
      </Padding>
    </FlexColumn>
  )
}

export { DocumentsEmptySection as Empty }
